module.exports = __webpack_public_path__ + "img/lava.4059620.png";